import CompanyDetailsSettings from "./CompanyDetailsSettings";

export default CompanyDetailsSettings;
